import { Box, Typography, styledComponent, Link } from '@hermes/web-components'

export const Container = styledComponent(Box)(() => ({
  padding: '16px',
  borderRadius: '16px',
  textAlign: 'start',
  width: '260px',
  border: '1px solid #D5DEF9',
  background: '#F4F7FD'
}))

export const ImagePlaceholder = styledComponent('div')(() => ({
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#9faabe',
  color: 'white',
  minWidth: '20px',
  minHeight: '20px'
}))

export const Text = styledComponent(Typography)(() => ({
  color: '#11245A',
  fontSize: '13px',
  lineHeight: '20px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  height: '20px',
  textOverflow: 'ellipsis',
  width: '100%'
}))

export const CustomLink = styledComponent(Link)(() => ({
  textDecoration: 'none'
}))

export const RecommendedFor = styledComponent(Box)(() => ({
  borderRadius: '16px',
  background: '#1A3586',
  textAlign: 'center',
  width: '100%',
  color: '#fff',
  fontSize: '13px',
  padding: '2px 12px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}))

export const ImageWrapper = styledComponent(Box)(() => ({
  width: '33px',
  height: '33px',
  borderRadius: '50%',
  border: '1px solid #00F',
  overflow: 'hidden'
}))
